import type { IconName } from "@nnf3d/svgs";

import type { ParentComponent } from "../lib/types";
import { booleanAttribute } from "../lib/utils";
import { Icon } from "./icon";

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
	icon?: IconName;
}

const Button: ParentComponent<ButtonProps> = ({ icon, children, ...props }) => (
	<button
		type="button"
		className="relative flex h-12 cursor-pointer touch-manipulation items-center justify-center bg-surface-primary px-5 text-xs text-foreground transition-colors duration-200 ease-out-quart select-none hover:bg-accent hover:text-surface-primary active:bg-accent-pressed active:text-surface-primary data-active:bg-accent data-active:text-surface-primary data-icon-only:w-17"
		data-icon-only={booleanAttribute(!children && icon)}
		{...props}
	>
		{children}

		{icon && (
			<Icon
				name={icon}
				className="ml-1.5 size-5 shrink-0 transition-colors duration-200 ease-out-quart data-icon-only:ml-0"
				data-icon-only={booleanAttribute(!children && icon)}
			/>
		)}
	</button>
);

export { Button };
